<!--
  프로모션 기능정의 샘플
  <template> 태그 안의 내용만 ADMIN에 HTML 로 저장
-->
<template>
  <div v-html="template"/>
</template>
<script>
import PromotionUi from '/src/assets/js/PromotionUi'
export default {
  name: 'CompPromotionHtml',
  mixins: [
    PromotionUi
  ],
  props: {
    template: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hasMotionEffect: true,
      scrollInterval: null
    }
  },
  mounted () {
    let nowTime = this.$moment(new Date()).format('YYYYMMDDHHmm')
    // 공통 프로모션 CSS 로드
    const promotionUiCss = document.createElement('link')
    promotionUiCss.rel = 'stylesheet'
    promotionUiCss.href = 'https://el.multicampus.com/de_common/mmp/assets/css/promotion_ui.css?version=' + nowTime
    document.head.appendChild(promotionUiCss)

    // 공통 프로모션 스크립트 로드
    const PromotionUiScript = document.createElement('script')
    PromotionUiScript.src = 'https://el.multicampus.com/de_common/mmp/assets/js/promotion_ui.js?version=' + nowTime
    PromotionUiScript.async = true
    document.head.appendChild(PromotionUiScript)

    this.$nextTick(() => {
      const urlHash = window.location.hash
      if (urlHash) this.scrollToEl(urlHash)
    })
  },
  beforeDestroy () {
    // 공통 프로모션 리소스 제거
    const promoCss = document.querySelectorAll('link[href^="https://el.multicampus.com/de_common/mmp/assets/css/promotion_ui.css"]')
    const promoUi = document.querySelectorAll('script[src^="https://el.multicampus.com/de_common/mmp/assets/js/promotion_ui.js"]')

    promoCss.forEach(css => css.remove())
    promoUi.forEach(script => script.remove())
  },
  methods: {
    clearScrollInterval () {
      if (this.scrollInterval !== null) {
        clearInterval(this.scrollInterval)
        this.scrollInterval = null
      }
    },
    scrollToEl (urlHash) {
      this.clearScrollInterval()
      this.scrollInterval = setInterval(() => {
        if (document.querySelector(urlHash)) {
          this.clearScrollInterval()

          setTimeout(() => {
            const targetEl = document.querySelector(urlHash)
            // 0.082: motionEffect에 적용된 transform 값
            let mfTrnsformValue = this.hasMotionEffect ? document.documentElement.clientHeight * 0.082 : 0
            const hOffset = 58 + mfTrnsformValue // 헤더 높이값 + motionEffent transform 값
            const elPos = targetEl.getBoundingClientRect().top
            const offsetPos = elPos + window.pageYOffset - hOffset
            window.scrollTo({
              top: offsetPos,
              behavior: 'smooth'
            })
          }, 400)
        }
      }, 400)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/board/CompPromotionHtml.vue